module.exports = __webpack_public_path__ + "static/img/realease-02.2edd468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/realease-02.png
// module id = 142
// module chunks = 0